export const INDUSTRY_IDS = Object.freeze({
    PRODUCT: 1,
    BOOKING: 2,
    PROFESSIONAL_SERVICES: 3,
    TRAINING: 4,
})

/** @param {Array<{ id: number }> | undefined | null} selectedIndustries */
export const hasProfessionalServicesIndustry = (selectedIndustries) => (
    Array.isArray(selectedIndustries) &&
    selectedIndustries.some((industry) => industry.id === INDUSTRY_IDS.PROFESSIONAL_SERVICES)
)
